/* eslint-disable @next/next/no-img-element */
import React from "react";
import { Grid } from "@mui/material";
import Link from "next/link";
import { htmlParse } from "@unisearch/helpers/utils";
import styles from "./uni_ranking.module.scss";
import CourseRankingCard from "@modules/study/common/course_ranking_card";

export const UniRanking = ({ rankingInfo, rankingOverviewText, ...rest }) => {
  const { rankingCompany, universityRanking } = rankingInfo;

  return (
    <section>
      <div className="container">
        <div className={styles.wrapper}>
          <div className={`${styles.title_wrapper} ${styles.heading}`}>
            <h2>Understanding University Rankings</h2>
            {rankingOverviewText ? (
              <>{rankingOverviewText && htmlParse(rankingOverviewText)}</>
            ) : (
              <div>
                <p>
                  In the process of researching universities you want to apply
                  to, you’ve likely run into university rankings. But what do
                  these numbers mean? A lot goes into informing the position a
                  university or college holds in some of the most popular
                  ranking lists. QS Top Universities, Times Higher Education, US
                  News, Shanghai Rankings, etc. all collect and analyse a lot of
                  data to determine what makes a university a great destination
                  for students. Understanding this data also helps you figure
                  out how to choose the right university for yourself!
                </p>
                <br />
                <p>
                  While each of the major world university rankings has its own
                  methodologies, using a set of indicators with different
                  weightages to calculate that #4 or =99 or #201-250, there are
                  a few consistent areas of overlap. Metrics typically look at
                  the quality of education, teaching quality, employability of
                  graduates, research outlook and reputation, research impact,
                  international outlook, and more, to determine a university’s
                  standing among thousands of other institutions. Because
                  different rankings prioritise different metrics and measure
                  and weigh them differently, you’ll also find that sometimes
                  the university ranking impressively high in one ranking holds
                  a more modest position elsewhere.
                </p>
                <br />

                <p>
                  So, what does it all mean? Rankings are definitely a good way
                  to shortlist universities you’re considering, especially when
                  broken down into subject rankings to see how a university
                  performs within a specific field. You can filter down your
                  university search based on your preferences, focusing more on
                  universities with a higher employability rate, or better
                  international outlook. Rankings aren’t, however, conclusive
                  information about how good one university is versus another.
                  After all, one can only estimate how great the teaching
                  environment is in a university, how friendly the community is
                  to international students, and how good of a fit it is to your
                  academic pursuits. The right university for you might not be
                  one that appears high up on a ranking list. So, it’s important
                  to use rankings to assist your university search, not limit
                  it!
                </p>
              </div>
            )}
          </div>

          <div className={styles.ranking_wrapper}>
            <Grid container spacing={4}>
              {universityRanking &&
                universityRanking.length > 0 &&
                universityRanking.map((rank, index) => {
                  return (
                    <Grid item xs={12} sm={12} md={6} key={`rank${index}`}>
                      <CourseRankingCard rank={rank} />
                    </Grid>
                  );
                })}
            </Grid>

            {rankingCompany && rankingCompany?.length > 0 && (
              <div className={styles.title_wrapper}>
                <h2>Top World University Rankings</h2>
                <p className={styles.short_description}>
                  Below, we list out the most comprehensive world university
                  rankings, which derive data from credible sources and use
                  validated methodologies and reliable metrics to see how
                  universities compare on a global scale.
                </p>

                <div className={styles.ranking_company_wrapper}>
                  <ul>
                    {rankingCompany &&
                      rankingCompany?.map((company, i) => {
                        return (
                          <li key={i}>
                            <Link
                              legacyBehavior
                              href={`/study/raniking-company/${company.slug}`}
                            >
                              <a>
                                {company?.logoImageSrc && (
                                  <div
                                    className={styles.rank_company_logo_wrapper}
                                  >
                                    <img
                                      src={company?.logoImageSrc}
                                      alt={company?.logoImageAlt}
                                    />
                                  </div>
                                )}
                                <div className={styles.rank_company_title}>
                                  {company?.rankingCompanyName}
                                </div>

                                {company?.description && (
                                  <div className={styles.rank_company_desc}>
                                    {htmlParse(company.description)}
                                  </div>
                                )}
                              </a>
                            </Link>
                          </li>
                        );
                      })}
                  </ul>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default UniRanking;
